import React, { FC, useEffect, useMemo, useState } from "react";
import { Panel } from "primereact/panel";
import { useHistory, useParams } from "react-router-dom";
import { StoreProductQuantityLimitationService } from "../../domain";
import { StoreProductQuantityLimitation } from "../../data";
import { TawreedAction, TawreedActionName } from "../../../../../common/actions";
import { tawreedTranslationService } from "../../../../../common/translations";
import { StoreProductAutoCompleteComponent } from "../../../store-products/presentaion/components/store-product-autocomplete.component";
import { PartnerAutoCompleteComponent } from "../../../../partners";
import { PartnerType } from "../../../../partners/data";
import { TawreedDropdown, TawreedForm, TawreedFormField, TawreedFormMode, TawreedFormSubmitAction, TawreedFormSubmitCallback, TawreedFormSubmitProps, TawreedInputNumber, TawreedInputPlain, TawreedInputSwitch, TawreedMenuDropdown } from "../../../../../common";
import { StoreProductSellerAutoCompleteComponent } from "../../../store-products/presentaion/components";
import { AuthUtils } from "../../../../auth/domain";
import { priceListDto, StoreProductDto } from "../../../store-products/domain";
import { PrimeIcons } from "primereact/api";
import { Routes } from "../../../../../router";
import { GlobalContext } from "../../../../../context";
import { PriceListServcie } from "../../../store-products/domain/services/price-list.service";

export const QuantityLimitationForm: FC = () => {
    // di
    const { id } = useParams<{ id: string | undefined }>();
    const service: StoreProductQuantityLimitationService = useMemo(() => new StoreProductQuantityLimitationService(), []);
    const history = useHistory();
    const [loading, setLoading] = useState<boolean>(false);
    const [mode, setMode] = React.useState<TawreedFormMode>('Create');
    const { auth: { user } } = React.useContext(GlobalContext);
    const [data, setData] = useState<StoreProductQuantityLimitation>({
        store: user?.roleCode === 'STORE_ADMIN' ? {partnerId:user.partnerId}: undefined,
    });

    const [activateToggle, setActivateToggle] = useState({
        activateCustomer: false,
        activateClass: false,
        activatePriceList: false
    });
 const [priceLists, setPriceLists] = useState<Array<priceListDto>>([]);
     const priceListService: PriceListServcie = useMemo(() => new PriceListServcie(), []);
    const [visible, setVisible] = React.useState(false);
    const [actions, setActions] = useState<TawreedAction[]>([]);
    let disabeld = true;

    const [state, setState] = React.useState<number>();
    React.useEffect(() => {
        let mounted = true;
        
        if (id) {
            if (mounted) {
                setMode('Edit');
                setLoading(true);
            }

            service.getDetails(Number.parseInt(id))
                .then(res => {
                    console.log(res);
                    if(res.customer){
                        setActivateToggle({...activateToggle, activateCustomer: true, activatePriceList: res.priceListId ? true : false})
                    }else{
                        if(res.classificationId){
                            setActivateToggle({...activateToggle, activateClass: true, activatePriceList: res.priceListId ? true : false})
                        }
                        else{
                            setActivateToggle({...activateToggle, activatePriceList: res.priceListId ? true : false})
                        }
                    }
                    if (mounted) {
                        setLoading(false);
                        setData(res);
                    }

                })
                .catch(() => {
                    if (mounted) {
                        setLoading(false);
                    }
                })

        }
        return () => {
            mounted = false;
        };
        // eslint-disable-next-line
    }, [id, service]);

    useEffect(()=>{
        if (priceLists.length == 0) {
            priceListService.getAll().then((res) => {
                setPriceLists(res);
            });
        }
    },[priceListService])
    useEffect(()=>{
        const next = [
            new TawreedAction(TawreedActionName.StoreProductQuantityLimitationDelete, 'statefull',  (e) => tawreedTranslationService.translate('lbl_remove_limitation'), PrimeIcons.TRASH, onRemove,'p-button-danger ml-1 p-button-text', 'confirm'),
        ];
        setActions(next);
    },[data])

    const onRemove = (): Promise<void> => {
        return new Promise((_resolve, reject) => {
            setLoading(false);
            return service.delete(Number.parseInt(id!))
            .then(()=>
            {
                history.replace(Routes.StoreProductQuantityLimitationSearch);
            }).catch(err => console.error(err));
        })
    }
const onCreateOrSave = (data: StoreProductQuantityLimitation, cb: TawreedFormSubmitCallback<StoreProductQuantityLimitation>): Promise<void> => {
        return new Promise((resolve, reject) => {
            setLoading(true);
            var newData = data;
            if(!activateToggle.activateClass)
                newData={...newData, classificationId: undefined};
            if(!activateToggle.activateCustomer)
                newData={...newData, customer: undefined};
            if(!activateToggle.activatePriceList)
                newData={...newData, priceListId: undefined};
            return service.createOrUpdate({ ...newData })
                .then(res => {
                    setLoading(false);
                    if (res) {
                        //history.replace(Routes.StoreProductQuantityLimitationDetails,);
                        history.push(Routes.StoreProductQuantityLimitationDetails.replace(':id', res.storeProductQuantityLimitationId!.toString()));
                    }
                })
                .catch(err => {
                    setLoading(false);
                    cb(err);
                });
        });
        
    }
    const onSubmit: TawreedFormSubmitProps<StoreProductQuantityLimitation> = {
        showButton: true,
        resetOnSubmit: false,
        onSubmit: new TawreedFormSubmitAction<StoreProductQuantityLimitation>(TawreedActionName.StoreProductQuantityLimitationSubmit, 'lbl_save', PrimeIcons.SAVE, onCreateOrSave, 'p-button-text'),
    };
    return (
        <React.Fragment>
            <TawreedForm title={'lbl_qunatity_limitation'}
                dataKey="storeProductQuantityLimitationId" data={data}
                submit={onSubmit}
                loading={loading} mode={mode}
                actions={actions} useBack={'..'}
                className="grid form-grid">
                <Panel header={tawreedTranslationService.translate('lbl_general_information')} className="col-12">
                    <div className="grid">
                    { user?.roleCode !== 'STORE_ADMIN' &&
                        <TawreedFormField name="store" title={"lbl_store_products_quantity_limitation_store_name"} className="field col-12 lg:col-12 md:col-12">
                            <PartnerAutoCompleteComponent partnerType={PartnerType.Store}
                                active={true}
                                autoCompleteName="store"
                                autoCompleteRules={{ required: 'msg_field_is_required' }}
                                autoCompleteField="partnerName"
                                autoCompleteOnSelect={e => {
                                    // props.onSelect(e.value);
                                    // setFocus('storeProduct');
                                    // setAddState({...addState, fromId: e.value.partnerId})
                                    setData({ ...data, store: e.value })
                                }}
                                // autoCompleteDisabled={props.disabled}
                                autoCompleteRender="form" />
                        </TawreedFormField>
                        }
                        <TawreedFormField name="storeProduct" title={"lbl_store_products_quantity_limitation_title"} className="field col-6 lg:col-6 md:col-6">

                            <StoreProductSellerAutoCompleteComponent
                                //storeId={.store?.partnerId}
                                partnerId={data.store ? data.store!.partnerId! : -1}
                                autoCompleteName="storeProduct"
                                autoCompleteField={AuthUtils.current().language === "en" ? "titleEn" : "titleAr"}
                                autoCompleteRules={{ required: "msg_field_is_required" }}
                                autoCompleteDisabled={(data.store) ? false : true}
                                autoCompleteRender="form"
                                autoCompleteOnSelect={e => {
                                    const p = e.value as StoreProductDto;
                                    if (p) {
                                        // setDialogState({
                                        //     ...dialogState,
                                        //     tax: p.tax,
                                        //     price: p.price,
                                        //     storeProductId: p.storeProductId,
                                        //     storeProductName: AuthUtils.current().language ==="en" ? p.titleEn : p.titleAr
                                        // });
                                        // setSellingPrice(p.price!);
                                        setData({ ...data, storeProduct: p })
                                    } else {
                                        setData({ ...data, storeProduct: undefined })
                                        // setDialogState({
                                        //     ...dialogState,
                                        //     tax: undefined,
                                        //     price: undefined,
                                        //     storeProductId: undefined,
                                        // });
                                        // setSellingPrice(0);
                                    }
                                }} />
                        </TawreedFormField>
                        <TawreedFormField name="quantity" className="field col-12 md:col-6" title="lbl_store_products_quantity_limitation_quantity">
                            <TawreedInputNumber render="form" name="quantity" rules={{ required: 'msg_field_is_required' }} />
                        </TawreedFormField>
                        <TawreedFormField className="field-checkbox col-2 md:col-2" name="classificationToggle" title="" flip>
                            <TawreedInputSwitch render="standalone"  checked={activateToggle.activateClass} onChange={(e)=>{
                            if(e.value){
                                setActivateToggle({
                                    ...activateToggle,
                                    activateClass: e.value,
                                    activateCustomer: false
                                })
                            }
                            else{
                                setActivateToggle({
                                    ...activateToggle,
                                    activateClass: e.value
                                })
                            }
                            }} />
                        </TawreedFormField>
                        <TawreedFormField name="classificationId" title={"lbl_store_products_quantity_limitation_classification"} className="field col-10 lg:col-10 md:col-10">

                            <TawreedMenuDropdown menu="classifications" name="classificationId" render="form" disabled={!activateToggle.activateClass}
                                value={state} onChange={(e) => setState(e.value)}
                                rules={{ validate: (value) => { 
                                    if(!value && activateToggle.activateClass)
                                    {
                                        return tawreedTranslationService.translate('lbl_whiteSapce_field');
                                    }

                                }}} />
                        </TawreedFormField>
                        <TawreedFormField className="field-checkbox col-2 md:col-2" name="customerToggle" title="" flip>
                            <TawreedInputSwitch render="standalone"  checked={activateToggle.activateCustomer} onChange={(e)=>{
                            if(e.value){
                                setActivateToggle({
                                    ...activateToggle,
                                    activateClass: false,
                                    activateCustomer: e.value
                                });
                            }
                            else{
                                setActivateToggle({
                                    ...activateToggle,
                                    activateCustomer: e.value
                                });
                            }
                            }} />
                        </TawreedFormField>
                        <TawreedFormField name="customer" title={"lbl_store_products_quantity_limitation_customer_name"} className="field col-10 lg:col-10 md:col-10">

                            <PartnerAutoCompleteComponent partnerType={PartnerType.Customer}
                                autoCompleteDisabled={!activateToggle.activateCustomer}
                                autoCompleteName="customer"
                                autoCompleteRules={{ validate: (value) => { 
                                    if(!value && activateToggle.activateCustomer)
                                    {
                                        return tawreedTranslationService.translate('lbl_whiteSapce_field');
                                    }

                                }}}
                                autoCompleteField="partnerName"
                                autoCompleteOnSelect={e => {
                                    // props.onSelect(e.value);
                                    // setFocus('storeProduct');
                                    // setAddState({...addState, fromId: e.value.partnerId})
                                    setData({ ...data, customer: e.value })
                                }}
                                // autoCompleteDisabled={props.disabled}
                                autoCompleteRender="form" />
                        </TawreedFormField>
                        
                        <TawreedFormField className="field-checkbox col-2 md:col-2" name="priceListToggle" title="" flip>
                            <TawreedInputSwitch render="standalone"  checked={activateToggle.activatePriceList} onChange={(e)=>{
                            
                            setActivateToggle({
                                ...activateToggle,
                                activatePriceList: e.value
                            });
                            }} />
                        </TawreedFormField>
                        <TawreedFormField name="priceListId" title={"lbl_store_products_quantity_limitation_price_list_name"} className="field col-10 lg:col-10 md:col-10">
                            <TawreedDropdown disabled={!activateToggle.activatePriceList} options={priceLists} name="priceListId"
                            optionLabel="priceListName" optionValue="priceListId" render="form" />
                        </TawreedFormField>
                    </div>
                </Panel>

            </TawreedForm>
            {/* {visible && <Dialog style={{ minWidth: '60%' }} header={tawreedTranslationService.translate("lbl_setItem")} visible={visible} footer={<DialogFooter />} onHide={()=>setVisible(false)} draggable={false} position="top" closable={true} closeOnEscape={true} maximizable>
                
            <TawreedFormField name="amount" title={"lbl_partners_Classification"} className="field col-12 lg:col-12 md:col-12">
                        <TawreedMenuDropdown menu="classifications" render="standalone"
                         value={state} onChange={(e)=>setState(e.value)}/>
                    </TawreedFormField>
            </Dialog>
}
             */}
        </React.Fragment>

    );
}
